module.exports = __webpack_public_path__ + "img/pa.812781e9.png";